export default __webpack_public_path__ + "static/media/landingMobile.742a53bf.mp4";